// Оттеночные темы: словарь и клиентские хелперы. Сами цвета — формула OKLCH в
// packages/ui/src/tokens.css (data-tint на <html>); здесь только список (для настроек,
// видео-студии и валидации рендера) и запись атрибут+localStorage. Акцент ВСЕГДА
// парный оттенку (переключатель убран по заказу 2026-07-13); «Крем» = фирменный
// малиновый. Ранняя инициализация до отрисовки — themeInitScript (components/theme.tsx).
//
// Палитры кураторские, из реальных тем топовых продуктов (см. коммент в tokens.css):
// Telegram Night, Stripe, Linear, GitHub Dim, Spotify, Dracula, Nord, Solarized, Bear.
// sw: [светлый фон-представитель, тёмный] для кружка-свотча; pair — акцент пары.

export const TINTS = [
  { id: 'cream', label: 'Крем — фирменный', sw: ['oklch(92% 0.035 85)', 'oklch(21% 0.02 75)'], pair: '#e23570' },
  { id: 'ivory', label: 'Айвори', sw: ['oklch(93% 0.025 85)', 'oklch(26% 0.014 60)'], pair: '#c6423e' },
  { id: 'solar', label: 'Солар', sw: ['oklch(93% 0.05 95)', 'oklch(28% 0.035 210)'], pair: '#cb4b16' },
  { id: 'midnight', label: 'Полночь', sw: ['oklch(91% 0.035 235)', 'oklch(26% 0.035 240)'], pair: '#2aabee' },
  { id: 'stripe', label: 'Индиго', sw: ['oklch(92% 0.03 245)', 'oklch(28% 0.055 252)'], pair: '#635bff' },
  { id: 'linear', label: 'Космос', sw: ['oklch(93% 0.008 260)', 'oklch(20% 0.006 260)'], pair: '#5e6ad2' },
  { id: 'github', label: 'Графит', sw: ['oklch(93% 0.015 255)', 'oklch(21% 0.02 255)'], pair: '#1f6feb' },
  { id: 'coal', label: 'Уголь', sw: ['oklch(95% 0.003 260)', 'oklch(21% 0.002 260)'], pair: '#1db954' },
  { id: 'dracula', label: 'Дракула', sw: ['oklch(93% 0.012 280)', 'oklch(30% 0.025 280)'], pair: '#e64ca6' },
  { id: 'nord', label: 'Норд', sw: ['oklch(92% 0.015 250)', 'oklch(32% 0.025 250)'], pair: '#5e81ac' },
  { id: 'mint', label: 'Изумруд', sw: ['oklch(93% 0.02 170)', 'oklch(23% 0.006 250)'], pair: '#10a37f' },
  { id: 'amoled', label: 'Контраст', sw: ['oklch(99% 0 0)', 'oklch(12% 0 0)'], pair: 'oklch(64% 0.19 356)' },
  // «Лагуна» (revolut) УДАЛЕНА (владелец 2026-07-26); выбор снятого оттенка чинит
  // AppearanceSync — сбрасывает на фирменный.
] as const;

export type TintId = (typeof TINTS)[number]['id'];

export const TINT_IDS = new Set<string>(TINTS.map((t) => t.id));

export const TINT_STORAGE_KEY = 'scriptera-tint';

export function currentTint(): TintId {
  if (typeof document === 'undefined') return 'cream';
  const v = document.documentElement.getAttribute('data-tint');
  return v && TINT_IDS.has(v) ? (v as TintId) : 'cream';
}

/** Применить оттенок: атрибут + localStorage. 'cream' = атрибут снят (фирменный вид). */
export function applyTint(id: TintId): void {
  const el = document.documentElement;
  if (id === 'cream') el.removeAttribute('data-tint');
  else el.setAttribute('data-tint', id);
  try {
    localStorage.setItem(TINT_STORAGE_KEY, id);
  } catch {
    /* приватный режим */
  }
}

// ── Примерки облика (владелец 10.08.2026) ─────────────────────────────────────
// Отдельная механика от оттенков: у оттенка цвета считаются формулой OKLCH, а тут
// три жёстких цвета (чёрный, белый, розовый #feb3c8) и разная раскраска слоёв —
// поэтому свой атрибут data-skin и своя палитра в tokens.css. Живут рядом с
// оттенками в одном пикере: снаружи это для человека один и тот же выбор вида.
// Осталась ОДНА схема и она же по умолчанию (владелец 10.08.2026): выбирать нечего,
// поэтому строки «Оттенок» в настройках больше нет. Остальные примерки удалены из
// выбора; их палитры лежат в tokens.css на случай возврата.
export const SKINS = [
  { id: 'mono', label: 'Моно', sw: ['#fbfaf9', '#14120f'], pair: '#feb3c8' },
] as const;

export type SkinId = (typeof SKINS)[number]['id'];

export const SKIN_IDS = new Set<string>(SKINS.map((s) => s.id));

export const SKIN_STORAGE_KEY = 'scriptera-skin';

export function currentSkin(): SkinId | null {
  if (typeof document === 'undefined') return null;
  const v = document.documentElement.getAttribute('data-skin');
  return v && SKIN_IDS.has(v) ? (v as SkinId) : null;
}

/** Применить примерку; null — снять и вернуть обычный вид кабинета. */
export function applySkin(id: SkinId | null): void {
  const el = document.documentElement;
  if (id) el.setAttribute('data-skin', id);
  else el.removeAttribute('data-skin');
  try {
    if (id) localStorage.setItem(SKIN_STORAGE_KEY, id);
    else localStorage.removeItem(SKIN_STORAGE_KEY);
  } catch {
    /* приватный режим */
  }
}

